module.exports = __webpack_public_path__ + "static/media/preloader.afaac856.gif";